import ru from "./ru";
import cn from "./cn";
import en from "./en";

export default {
  en: {
    message: en,
  },
  cn: {
    message: cn,
  },
  ru: {
    message: ru,
  },
};
